(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sliders = document.querySelectorAll('[data-hero-slider]');

    sliders.forEach(function(slider) {
      var slides = slider.querySelectorAll('.hero-slider__slide');
      var dots = slider.querySelectorAll('[data-slider-dot]');
      var prevBtn = slider.querySelector('[data-slider-prev]');
      var nextBtn = slider.querySelector('[data-slider-next]');
      var speed = parseInt(slider.dataset.sliderSpeed) || 5000;
      var autoplayEnabled = slider.dataset.sliderAutoplay !== 'false';

      if (slides.length <= 1) return;

      var currentIndex = 0;
      var autoPlayTimer = null;
      var isHovered = false;

      function resetDotAnimation(dotIndex) {
        var progress = dots[dotIndex] ? dots[dotIndex].querySelector('.hero-slider__dot-progress') : null;
        if (progress) {
          progress.style.animation = 'none';
          void progress.offsetHeight;
          progress.style.animation = '';
        }
      }

      function goToSlide(index) {
        if (index === currentIndex) return;

        slides[currentIndex].classList.remove('hero-slider__slide--active');
        if (dots[currentIndex]) {
          dots[currentIndex].classList.remove('hero-slider__dot--active');
        }
        resetDotAnimation(currentIndex);

        currentIndex = index;
        slides[currentIndex].classList.add('hero-slider__slide--active');
        if (dots[currentIndex]) {
          dots[currentIndex].classList.add('hero-slider__dot--active');
        }
        resetDotAnimation(currentIndex);

        restartAutoPlay();
      }

      function nextSlide() {
        goToSlide((currentIndex + 1) % slides.length);
      }

      function prevSlide() {
        goToSlide((currentIndex - 1 + slides.length) % slides.length);
      }

      function startAutoPlay() {
        stopAutoPlay();
        if (!isHovered && autoplayEnabled) {
          autoPlayTimer = setInterval(nextSlide, speed);
        }
      }

      function stopAutoPlay() {
        if (autoPlayTimer) {
          clearInterval(autoPlayTimer);
          autoPlayTimer = null;
        }
      }

      function restartAutoPlay() {
        stopAutoPlay();
        startAutoPlay();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          prevSlide();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          nextSlide();
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          var idx = parseInt(this.dataset.sliderDot);
          goToSlide(idx);
        });
      });

      slider.addEventListener('mouseenter', function() {
        isHovered = true;
        stopAutoPlay();
        var progress = dots[currentIndex] ? dots[currentIndex].querySelector('.hero-slider__dot-progress') : null;
        if (progress) progress.style.animationPlayState = 'paused';
      });

      slider.addEventListener('mouseleave', function() {
        isHovered = false;
        startAutoPlay();
        var progress = dots[currentIndex] ? dots[currentIndex].querySelector('.hero-slider__dot-progress') : null;
        if (progress) progress.style.animationPlayState = 'running';
      });

      var touchStartX = 0;
      var touchStartTime = 0;

      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartTime = Date.now();
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        var elapsed = Date.now() - touchStartTime;

        if (Math.abs(diff) > 50 || (Math.abs(diff) > 30 && elapsed < 300)) {
          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        }
      }, { passive: true });

      slider.setAttribute('tabindex', '0');
      slider.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          prevSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          nextSlide();
        }
      });

      startAutoPlay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
